module.exports = __webpack_public_path__ + "img/Reporting.fb888da6.png";